export const ONBOARDING_STEPS = [
  {
    active: true,
    mandatory: true,
    success: false,
    title: 'Content certification',
    sections: [
      {
        title: 'Hotels',
        description:
          'In this step, you’ll need to implement and validate the necessary methods to retrieve static content from our API. This includes updating and verifying hotel lists and other related static data.',
        totalFiles: 1,
        totalFilesOk: 0,
        stepsFlow: [
          {
            name: 'Hotels',
            description:
              'Make sure the response contains at least one hotel whose hotelCode matches the one used in the request.',
            files: [
              {
                scenario: 'rs_hotels',
                label: 'RS Hotels',
                file: 'rs_hotels.json',
                status: null,
                error: null,
              },
            ],
          },
        ],
        hasErrors: false,
      },
    ],
  },
  {
    active: false,
    mandatory: true,
    success: false,
    title: 'Case: Refundable',
    sectionCompleted: 0,
    sections: [
      {
        title: 'Booking Flow',
        description: `This certification step aims to validate your ability to perform a complete booking flow by searching for a specific Case (C1), and selecting a refundable option for 3 rooms with the following occupancy:
            · 1 room with 3 adults
            · 1 room with 2 adults and 1 child (5 years old)
            · 1 room with 2 adults`,
        totalFiles: 6,
        totalFilesOk: 0,
        stepsFlow: [
          {
            name: 'Search',
            files: [
              {
                scenario: 'rq_search_rf',
                label: 'RQ Search',
                file: 'rq_search_rf.json',
                status: null,
                error: null,
              },
              {
                scenario: 'rs_search_rf',
                label: 'RS Search',
                file: 'rs_search_rf.json',
                status: null,
                error: null,
              },
            ],
          },
          {
            name: 'Quote',
            files: [
              {
                scenario: 'rq_quote_rf',
                label: 'RQ Quote',
                file: 'rq_quote_rf.json',
                status: null,
                error: null,
              },
              {
                scenario: 'rs_quote_rf',
                label: 'RS Quote',
                file: 'rs_quote_rf.json',
                status: null,
                error: null,
              },
            ],
          },
          {
            name: 'Book',
            files: [
              {
                scenario: 'rq_book_rf',
                label: 'RQ Book',
                file: 'rq_book_rf.json',
                status: null,
                error: null,
              },
              {
                scenario: 'rs_book_rf',
                label: 'RS Book',
                file: 'rs_book_rf.json',
                status: null,
                error: null,
              },
            ],
          },
        ],
        hasErrors: false,
      },
      {
        title: 'Booking Management',
        description:
          'This step aims to validate your ability to cancel reservations and check their status by implementing the reservationRead method, along with the additional reservationList method.',
        totalFiles: 4,
        totalFilesOk: 0,
        stepsFlow: [
          {
            name: 'Cancel',
            files: [
              {
                scenario: 'rq_cancel_rf',
                label: 'RQ Cancel',
                file: 'rq_cancel_rf.json',
                status: null,
                error: null,
              },
              {
                scenario: 'rs_cancel_rf',
                label: 'RS Cancel',
                file: 'rs_cancel_rf.json',
                status: null,
                error: null,
              },
            ],
          },
          {
            name: 'Booking Read',
            files: [
              {
                scenario: 'rq_booking',
                label: 'RQ Booking',
                file: 'rq_booking.json',
                status: null,
                error: null,
              },
              {
                scenario: 'rs_booking',
                label: 'RS Booking',
                file: 'rs_booking.json',
                status: null,
                error: null,
              },
            ],
          },
        ],
        hasErrors: false,
      },
    ],
  },
  {
    active: false,
    mandatory: true,
    success: false,
    title: 'Case: Non Refundable',
    sections: [
      {
        title: 'Booking Flow',
        description: `This certification step corresponds to Case 2 (C2) and aims to validate your ability to complete a full booking flow using a non-refundable option for 2 rooms with the following occupancy:
            · 1 room with 2 adults and 1 child (5 years old)
            · 1 room with 2 adults`,
        totalFiles: 6,
        totalFilesOk: 0,
        stepsFlow: [
          {
            name: 'Search',
            files: [
              {
                scenario: 'rq_search_nrf',
                label: 'RQ Search',
                file: 'rq_search_nrf.json',
                status: null,
                error: null,
              },
              {
                scenario: 'rs_search_nrf',
                label: 'RS Search',
                file: 'rs_search_nrf.json',
                status: null,
                error: null,
              },
            ],
          },
          {
            name: 'Quote',
            files: [
              {
                scenario: 'rq_quote_nrf',
                label: 'RQ Quote',
                file: 'rq_quote_nrf.json',
                status: null,
                error: null,
              },
              {
                scenario: 'rs_quote_nrf',
                label: 'RS Quote',
                file: 'rs_quote_nrf.json',
                status: null,
                error: null,
              },
            ],
          },
          {
            name: 'Book',
            files: [
              {
                scenario: 'rq_book_nrf',
                label: 'RQ Book',
                file: 'rq_book_nrf.json',
                status: null,
                error: null,
              },
              {
                scenario: 'rs_book_nrf',
                label: 'RS Book',
                file: 'rs_book_nrf.json',
                status: null,
                error: null,
              },
            ],
          },
        ],
        hasErrors: false,
      },
      {
        title: 'Booking Management',
        description:
          'This certification step is to clarify that, although the selected option is non-refundable, a cancellation request can still be submitted and may incur cancellation fees.',
        totalFiles: 2,
        totalFilesOk: 0,
        stepsFlow: [
          {
            name: 'Cancel',
            files: [
              {
                scenario: 'rq_cancel_nrf',
                label: 'RQ Cancel',
                file: 'rq_cancel_nrf.json',
                status: null,
                error: null,
              },
              {
                scenario: 'rs_cancel_nrf',
                label: 'RS Cancel',
                file: 'rs_cancel_nrf.json',
                status: null,
                error: null,
              },
            ],
          },
        ],
        hasErrors: false,
      },
    ],
  },
  {
    active: false,
    mandatory: false,
    success: false,
    title: 'Case: Payment Card (optional)',
    sections: [
      {
        title: 'Booking Flow',
        description: `This certification step corresponds to Case 3 (C3) and aims to validate your ability to complete a full booking flow using credit card details for a DIRECT, CARD_BOOKING, and CARD_CHECK_IN payment option, with the following occupancy:
              · 1 room with 2 adults`,
        totalFiles: 6,
        totalFilesOk: 0,
        stepsFlow: [
          {
            name: 'Search',
            files: [
              {
                scenario: 'rq_search_direct',
                label: 'RQ Search',
                file: 'rq_search_direct.json',
                status: null,
                error: null,
              },
              {
                scenario: 'rs_search_direct',
                label: 'RS Search',
                file: 'rs_search_direct.json',
                status: null,
                error: null,
              },
            ],
          },
          {
            name: 'Quote',
            files: [
              {
                scenario: 'rq_quote_direct',
                label: 'RQ Quote',
                file: 'rq_quote_direct.json',
                status: null,
                error: null,
              },
              {
                scenario: 'rs_quote_direct',
                label: 'RS Quote',
                file: 'rs_quote_direct.json',
                status: null,
                error: null,
              },
            ],
          },
          {
            name: 'Book',
            files: [
              {
                scenario: 'rq_book_direct',
                label: 'RQ Book',
                file: 'rq_book_direct.json',
                status: null,
                error: null,
              },
              {
                scenario: 'rs_book_direct',
                label: 'RS Book',
                file: 'rs_book_direct.json',
                status: null,
                error: null,
              },
            ],
          },
        ],
        hasErrors: false,
      },
      {
        title: 'Booking Management',
        description:
          'This certification step is simply to ensure that you request the cancellation of any test bookings. Please note that any future test bookings made using your own API key that are not cancelled will be invoiced after the check-in date.',
        totalFiles: 2,
        totalFilesOk: 0,
        stepsFlow: [
          {
            name: 'Cancel',
            files: [
              {
                scenario: 'rq_cancel_direct',
                label: 'RQ Cancel',
                file: 'rq_cancel_direct.json',
                status: null,
                error: null,
              },
              {
                scenario: 'rs_cancel_direct',
                label: 'RS Cancel',
                file: 'rs_cancel_direct.json',
                status: null,
                error: null,
              },
            ],
          },
        ],
        hasErrors: false,
      },
    ],
  },
  { active: false, success: false, title: 'Confirm' },
];
